// extracted by css-extract-rspack-plugin
export default {"content-wrapper":"DashboardBanner-module__content-wrapper--CE7w8","contentWrapper":"DashboardBanner-module__content-wrapper--CE7w8"};